import { useEffect, useRef } from 'react';

/**
 * A custom hook that returns the current and previous object/value.
 *
 * @template T The type of data.
 * @param {T} value - The value to track
 * @returns {{ current: T, prev: T | undefined }} Object containing current and previous values
 */
export const usePrevious = <T>(
    value: T
): { current: T; prev: T | undefined } => {
    const prevValueRef = useRef<T>();
    useEffect(() => {
        prevValueRef.current = value;
    }, [value]);

    return { current: value, prev: prevValueRef.current };
};
